export default __webpack_public_path__ + "static/media/andromeda.guia-1.6c2997f0.png";